import { FormField, SidebarFolder } from "@/interfaces/dashboard";

export const SIDEBAR_FOLDERS: SidebarFolder[] = [
  { id: 'eraserbot', icon: '🤖', label: 'Eraserbot', shortcut: 'B', badge: 'BETA' },
  { id: 'references', icon: '📚', label: 'AI References', shortcut: 'C' },
  { id: 'templates', icon: '📋', label: 'Team Templates', shortcut: 'T' },
  { id: 'github', icon: '🔗', label: 'Github Sync', shortcut: 'G', badge: 'BETA' },
  { id: 'private', icon: '🔒', label: 'Private Files', shortcut: '', variant: 'upgrade' },
  { id: 'archive', icon: '📦', label: 'Archive', shortcut: 'E' },
];

export const PROJECT_FORM_FIELDS: FormField[] = [
  {
    id: 'name',
    name: 'name',
    label: 'Project Name',
    type: 'text',
    placeholder: 'Enter project name',
    required: true,
  },
  {
    id: 'description',
    name: 'description',
    label: 'Description (Optional)',
    type: 'textarea',
    placeholder: 'Add a description...',
    rows: 3,
  },
];

export const TABLE_HEADERS = [
  { key: 'name', label: 'NAME', align: 'center', sortable: false },
  // { key: 'location', label: 'LOCATION', align: 'left', sortable: false },
  { key: 'created', label: 'CREATED', align: 'center', sortable: false },
  { key: 'edited', label: 'EDITED', align: 'center', sortable: false },
  { key: 'comments', label: 'COMMENTS', align: 'center', sortable: false },
  { key: 'actions', label: 'AcTIONS', align: 'center', sortable: false },
] as const;